export default "__VITE_ASSET__B0RV5BqK__"